type WithMongoId = { id?: string; _id?: string };

export function getEntityId(entity: WithMongoId | null | undefined): string {
  if (!entity) return '';
  const raw = entity.id ?? entity._id;
  return raw != null ? String(raw) : '';
}
